import { Component, Input } from '@angular/core';
import { AssetCollectionEditFormType } from '../asset-collection-edit-form-type';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { AppErrorMessagesComponent } from "../../../../base/error-messages/app-error-messages.component";
import { DatePickerModule, MaskedDateTimeService } from '@syncfusion/ej2-angular-calendars';
import { YesNoGroupButtonComponent } from 'src/app/base/shared/yes-no-group-button/yes-no-group-button.component';
import { TooltipModule } from '@syncfusion/ej2-angular-popups';
import { GridBaseComponent } from 'src/app/base/shared/grid-base/grid-base.component';
import { CommandModel, GridModule } from '@syncfusion/ej2-angular-grids';
import { AssetCollectionsEditService } from './asset-collections-edit.service';
import { AssetCollectionAssetDTO } from 'src/app/base/models/models.swagger.generated';
import { AssetConfigurationsService } from '../../asset-configurations.service';

@Component({
    selector: 'app-asset-collections-edit',
    templateUrl: './asset-collections-edit.component.html',
    styleUrl: './asset-collections-edit.component.scss',
    imports: [TranslateModule, ReactiveFormsModule, AppErrorMessagesComponent, DatePickerModule, YesNoGroupButtonComponent, TooltipModule, CommonModule, GridModule],
    providers: [MaskedDateTimeService]
})
export class AssetCollectionsEditComponent extends GridBaseComponent<any> {

  @Input() public editForm: FormGroup<AssetCollectionEditFormType>;
  @Input() public assets: AssetCollectionAssetDTO[];

  constructor(translateService: TranslateService,
    private assetCollectionsEditService: AssetCollectionsEditService,
    private assetConfigurationsService: AssetConfigurationsService) {
    super(translateService, assetCollectionsEditService);

    this.gridCommands = [{
      type: 'None',
      title: this.translateService.instant('i18n.domain.assets.asset-collections.edit.remove-asset-dialog-title'),
      buttonOption:
      {
        cssClass: 'icon-btn',
        iconCss: 'icon-trash-can e-icons'
      }
    } as CommandModel];
  }

  public getPreviewLink(dto: AssetCollectionAssetDTO): string {
    var fileExtension = dto.relativePathAndName.split('.').pop().toLowerCase();
    if (fileExtension === 'pdf') {
      return 'assets/img/PDF_file_icon.svg';
    }

    if (this.assetConfigurationsService.assetConfiguration?.supportedAssetImageFileExtensions.includes('.' + fileExtension)) {
      return dto.fileLink;
    }

    return 'assets/img/document_unspecified.svg';
  }

  public getLocalFileName(dto: AssetCollectionAssetDTO): string {
    return dto.relativePathAndName.split('\\').pop().split('.')[0];
  }

  public getPublicFileName(dto: AssetCollectionAssetDTO): string {
    return dto.publicName.split('.')[0];
  }

  public getFileEnding(dto: AssetCollectionAssetDTO): string {
    if (dto.isFile) {
      return dto.relativePathAndName.split('.').pop();
    }
    else {
      return this.translateService.instant('i18n.domain.assets.asset-collections.edit.type-folder');
    }
  }

  protected override initializeEditForm(data: any): void {
    throw new Error('Method not implemented.');
  }
  protected override getEditDialogTitleParams(rowData: any): object {
    throw new Error('Method not implemented.');
  }

  public override commandClicked(args: any): void {
    if (args.commandColumn.buttonOption.iconCss.includes('icon-trash-can')) {
      this.modalHelperService.confirm(
        'i18n.domain.assets.asset-collections.edit.remove-asset-dialog-title',
        'i18n.domain.assets.asset-collections.edit.remove-asset-dialog-question',
        () => {
          this.assets.splice(this.assets.findIndex((asset) => asset.id === args.rowData.id), 1);
          this.editForm.controls.assets.setValue(this.assets);
          this.grid.refresh();
        }
      );
      args.cancel = true;
    }
  }

  public generateToken(): void {
    this.editForm.controls.token.enable({ emitEvent: false });
    this.editForm.controls.token.setValue(this.assetCollectionsEditService.generateToken());
    this.editForm.controls.token.markAsDirty();
    this.editForm.controls.token.updateValueAndValidity({ onlySelf: true, emitEvent: true });
    this.editForm.controls.token.disable({ emitEvent: false });
  }

}
